module.exports = __webpack_public_path__ + "static/team-5-060da707db005188785844faa07ea848.png";